import { useState } from "react";
import BaseLoading from "../loading/BaseLoading";
import { IButtonProps } from "../../properties/ButtonProperties";

const CancelButton = ({
  title,
  size,
  onClick,
  disabled,
  block,
  fixedWidth,
  beam,
}: IButtonProps) => {
  const [loading, setLoading] = useState(false);

  const internalOnClick = async (e: any) => {
    e.stopPropagation();
    if (loading) return;
    if (disabled) return;
    setLoading(true);
    await onClick();
    setLoading(false);
  };

  let currentHeightClassName = "";
  let currentLoadingSize;
  if (size === "small") {
    currentHeightClassName = "btn-h-8";
    currentLoadingSize = 14;
  } else if (size === "medium") {
    currentHeightClassName = "btn-h-10";
    currentLoadingSize = 16;
  } else if (size === "large") {
    currentHeightClassName = "btn-h-12";
    currentLoadingSize = 18;
  } else if (size === "unlimited") {
    currentHeightClassName = "btn-h-8";
    currentLoadingSize = 14;
  }

  return (
    <button
      className={`btn-base btn-delete ${
        loading ? "btn-loading" : disabled ? "btn-disabled" : ""
      } ${beam ? "btn-beam" : ""} ${block ? "btn-block" : fixedWidth ? "btn-w" : ""} ${currentHeightClassName}`}
      disabled={disabled || loading}
      onClick={internalOnClick}
    >
      {loading ? (
        <BaseLoading
          height={currentLoadingSize}
          width={currentLoadingSize}
          primaryColor="#55777f"
          secondaryColor="#55777f"
        />
      ) : (
        <div className="btn-content">
          <span>{title}</span>
        </div>
      )}
    </button>
  );
};

export default CancelButton;
